import * as React from "react";

import { ProductList } from "@components/organisms";

import { ProductDetails_product_category_products_edges } from "./gqlTypes/ProductDetails";

const OtherProducts: React.FC<{
  products: ProductDetails_product_category_products_edges[];
  currentProductId: string;
}> = ({ products, currentProductId }) => {
  const otherProducts = products
    .map(({ node }) => node)
    .filter(({ id }) => id !== currentProductId)
    .slice(0, 3);

  if (!otherProducts.length) {
    return null;
  }

  return (
    <div className="product-page__other-products">
      <div className="container">
        <h4 className="product-page__other-products__title">
          Other products in this category
        </h4>
        <ProductList products={otherProducts} />
      </div>
    </div>
  );
};

export default OtherProducts;
